import { navLinks } from "../../../mocks/homeData";

const categoryList = ["娱乐饭圈", "综艺影视", "电竞游戏", "科技数码", "职场社会", "生活八卦"];

export default function Footer() {
  return (
    <footer className="border-t border-background-300 bg-background-200">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          {/* brand */}
          <div>
            <a href="#top" className="flex items-center gap-2 cursor-pointer whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 font-display text-xl text-white">9</span>
              <span className="font-serif text-xl font-bold text-foreground-950">看料</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-700">
              9看料热瓜追踪频道，栏目化整理热门大瓜与热搜话题，逐日刷新爆款瓜热度排行，帮你在瓜棚里吃得明白、追得省心。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-fill", "ri-bilibili-fill", "ri-douban-fill", "ri-zhihu-fill"].map((ic, i) => (
                <a
                  key={i}
                  href="#contact"
                  aria-label="关注我们"
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 bg-background-100 text-foreground-800 transition-colors hover:bg-primary-500 hover:text-white hover:border-primary-500 cursor-pointer"
                >
                  <i className={`${ic} w-4 h-4 flex items-center justify-center`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* columns */}
          <div>
            <h4 className="font-serif text-base font-bold text-foreground-950">栏目导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categoryList.map((c) => (
                <li key={c}>
                  <a href="#categories" className="text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer">
                    {c}追踪
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-serif text-base font-bold text-foreground-950">站内索引</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navLinks.map((n) => (
                <li key={n.id}>
                  <a href={`#${n.id}`} className="text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* about text */}
          <div>
            <h4 className="font-serif text-base font-bold text-foreground-950">关于 9看料</h4>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              9看料专注于热门爆料与热搜话题的持续跟进与热度排行。我们坚持只做公开信息的整理呈现，存疑即标注、以权威信源为锚，让追瓜成为一件清醒而有分寸的事。
            </p>
            <a href="#contact" className="mt-4 inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700 cursor-pointer">
              <i className="ri-mail-send-line w-4 h-4 flex items-center justify-center"></i>
              联系编辑部
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-background-300 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">© 2026 9看料 · 热门大瓜追踪榜。本站内容仅为公开信息的趋势整理，不代表任何立场与结论。</p>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <a href="#about" className="hover:text-primary-600 transition-colors cursor-pointer">追踪说明</a>
            <span>·</span>
            <a href="#faq" className="hover:text-primary-600 transition-colors cursor-pointer">常见问题</a>
            <span>·</span>
            <a href="#contact" className="hover:text-primary-600 transition-colors cursor-pointer">投稿纠错</a>
          </div>
        </div>
      </div>
    </footer>
  );
}